goog.provide("shadow.js.shim.module$src$svg$controls$view_list_svg$default");
shadow.js.shim.module$src$svg$controls$view_list_svg$default = shadow.js.shim.module$src$svg$controls$view_list_svg.default;
